export default "__VITE_ASSET__3e3966e5__"